import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Intro = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isEnglish = location.pathname.startsWith("/en");

  return (
    <section>
      <div className="intro">
        <div className="container-intro-txt">
          <img
            src="/assets/img/logo.webp"
            alt="YASKIA"
            title="YASKIA"
            className="yaskia"
          />
          <article>{t("home.intro")}</article>
          <Link to={isEnglish ? "/en/about" : "/quienes-somos"} className="btn">
            {t("home.introbutton")}
          </Link>
        </div>
        <div
          className="container-intro-img"
          style={{
            backgroundImage: `url('/assets/img/img-home-intro.webp')`,
          }}
        ></div>
      </div>
    </section>
  );
};

export default Intro;
